var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFacebookFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Social Media / Facebook",
    clipPath: "url(#clip0_40139_241493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8.99999 0.0390625C4.04999 0.0390625 0 4.08006 0 9.05705C0 13.557 3.294 17.292 7.59599 17.967V11.667H5.30999V9.05705H7.59599V7.06805C7.59599 4.80906 8.93699 3.56706 10.998 3.56706C11.979 3.56706 13.005 3.73806 13.005 3.73806V5.96106H11.871C10.755 5.96106 10.404 6.65405 10.404 7.36505V9.05705H12.906L12.501 11.667H10.404V17.967C12.5248 17.6321 14.456 16.55 15.8489 14.9161C17.2419 13.2822 18.0048 11.2041 18 9.05705C18 4.08006 13.95 0.0390625 8.99999 0.0390625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40139_241493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFilled);
export default __webpack_public_path__ + "static/media/facebookFilled.326b3452f02070de5b1065676b1ad8d2.svg";
export { ForwardRef as ReactComponent };